/**
 * impersonation.js — Phase 12.57 · header de "modo ghost".
 *
 * Quando um Super Admin impersona um cliente (Admin Geral › Clientes ›
 * Impersonar), o JWT continua sendo o DELE — sem `workspace_id`/`empresa_id`.
 * Enviamos o workspace-alvo em `X-Imp-Workspace`; o backend só o aceita se o
 * token tiver `is_super_adm=true`.
 */
const IMP_HEADER = "X-Imp-Workspace";

export function impersonationWorkspaceId() {
  try {
    const raw = localStorage.getItem("imp_session");
    if (!raw) return null;
    const imp = JSON.parse(raw);
    if (!imp?.workspace_id) return null;
    if (imp.expires_at && new Date(imp.expires_at).getTime() < Date.now()) return null;
    return imp.workspace_id;
  } catch {
    return null;
  }
}

/**
 * Contexto V360 do Super Admin (Jun/2026).
 *
 * O Super Admin não tem workspace próprio. Quando ele entra numa empresa pelo
 * V360 (`?empresa=<uuid>`) sem link ghost, o S360 não tinha tenant: caía no
 * bucket DEMO e exibia os projetos mock de outra empresa. Guardamos aqui o
 * workspace resolvido a partir do perfil da empresa.
 */
const V360_CTX_KEY = "v360_ctx";

export function getV360Ctx() {
  try {
    return JSON.parse(localStorage.getItem(V360_CTX_KEY) || "null");
  } catch {
    return null;
  }
}

export function setV360Ctx(ctx) {
  try {
    localStorage.setItem(V360_CTX_KEY, JSON.stringify(ctx));
    window.dispatchEvent(new CustomEvent("imp-session-changed"));
  } catch { /* noop */ }
}

export function clearV360Ctx() {
  try {
    if (!localStorage.getItem(V360_CTX_KEY)) return;
    localStorage.removeItem(V360_CTX_KEY);
    window.dispatchEvent(new CustomEvent("imp-session-changed"));
  } catch { /* noop */ }
}

function ctxWorkspaceId() {
  try {
    const s = JSON.parse(localStorage.getItem("app_session") || "null");
    // Só vale para Super Admin sem workspace próprio — para o cliente comum o
    // tenant é sempre o do próprio `app_session`.
    if (!s?.is_super_adm || s?.workspace_id) return null;
    return getV360Ctx()?.workspace_id || null;
  } catch {
    return null;
  }
}

export function impHeaders() {
  const ws = impersonationWorkspaceId() || ctxWorkspaceId();
  return ws ? { [IMP_HEADER]: ws } : {};
}

/**
 * Workspace efetivo para escopo de dados no cliente (buckets de localStorage,
 * preferências por tenant). Ghost e contexto V360 têm precedência sobre a
 * sessão do admin (que não tem workspace).
 */
export function scopeWorkspaceId() {
  const imp = impersonationWorkspaceId() || ctxWorkspaceId();
  if (imp) return imp;
  try {
    const s = JSON.parse(localStorage.getItem("app_session") || "null");
    return s?.workspace_id || null;
  } catch {
    return null;
  }
}
